module.exports = __webpack_public_path__ + "static/unknownIcon-a239955dfa4a9cf595df100a13257d9c.png";